// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Grid Layout UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
:root {
  /* ezClocker Font Famlies */
  --ezLayoutGrid-row-label-font-size: 12pt;
}

/* -------------------------------------------------------------------
| Page Grid Layout Styles
------------------------------------------------------------------- */
.ezHtml {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
}

.ezPageHeader {
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
}

.ezFixedPageHeader {
  position: fixed;
  top: 0;
  width: 100%;
}

.ezPageBody {
  display: grid;
  align-content: start;
  margin: var(--ezBodyMarginSize);
  padding: var(--ezBodyPaddingSize);
  background-color: var(--ezAlphaBackgroundWhite1);
  background-size: var(--ezBackgroundImageSize);
  background-image: var(--ezBackgroundImage);
  color: var(--ezContentFontColor);
  font-size: var(--ezContentFontSize);
  font-family: var(--ezFontFamily);
  font-weight: var(--ezContentFontWeight);
  font-style: var(--ezContentFontStyle);
}

.ezPageBody-no-scroll {
  display: grid;
  align-content: start;
  margin: var(--ezBodyMarginSize);
  padding: var(--ezBodyPaddingSize);
  background-color: var(--ezAlphaBackgroundWhite1);
  background-size: var(--ezBackgroundImageSize);
  background-image: var(--ezBackgroundImage);
  color: var(--ezContentFontColor);
  font-size: var(--ezContentFontSize);
  font-family: var(--ezFontFamily);
  font-weight: var(--ezContentFontWeight);
  font-style: var(--ezContentFontStyle);
  overflow: hidden;
}

.ezPageView {
  display: grid;
  margin: 0;
  padding: 0;
  align-content: start;
  background-color: transparent;
}

.ezPageView-no-scroll {
  display: grid;
  margin: 0;
  padding: 0;
  align-content: start;
  background-color: transparent;
  overflow: hidden;
}

.ezPageViewHeader {
  display: grid;
  align-content: start;
  grid-template-columns: 100%;
  background-color: transparent;
  overflow: hidden;
}

.ezPageSection {
  display: grid;
  padding: 0;
  margin: 0;
  align-content: start;
  grid-template-columns: 100%;
  background-color: transparent;
  overflow: hidden;
}

.ezContentView {
  margin-top: 4px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 0;
  background-color: transparent;
  overflow: auto;
}

.ezContentSection {
  margin: 0;
  padding: 0;
  background-color: transparent;
}

.ezContentSection-vertical-scroll {
  margin: 0;
  padding: 0;
  background-color: transparent;
  overflow-y: scroll;
  overflow-x: hidden;
}

.ezContent-grid-col-section-50x50 {
  display: grid;
  margin: 0;
  padding: 0;
  grid-row-gap: 0;
  grid-column-gap: 4px;
  grid-template-columns: 50% 50%;
  background-color: transparent;
}

.ezContentSection-inset-border-2-radius-bottom-pad4-vscroll {
  margin: 0;
  padding: 4px;
  background-color: transparent;
  overflow-y: scroll;
  overflow-x: hidden;
  border-color: var(--ezClockerBlack);
  border-style: solid;
  border-width: 2px;
  border-radius: 3px;
}

.ezBorderlessSubContentView {
  display: grid;
  padding: 0;
  align-content: stretch;
  justify-content: stretch;
  background-color: transparent;
  color: var(--ezFontColor);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
  border-style: none;
}

.ezSubContentView {
  display: grid;
  padding: 8px;
  align-content: stretch;
  justify-content: stretch;
  background-color: var(--ezClockerWhite);
  color: var(--ezFontColor);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
  border-color: var(--ezClockerSilver);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezSubContentView-no-scroll {
  background-color: var(--ezClockerWhite);
  color: var(--ezFontColor);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
  border-color: var(--ezClockerSilver);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  overflow: hidden;
}

.ezSubContentView_vertical {
  padding: 8px;
  background-color: var(--ezClockerWhite);
  color: var(--ezFontColor);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
  border-color: var(--ezClockerSilver);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezSubContentView-no-border {
  padding: 8px;
  background-color: var(--ezClockerWhite);
  color: var(--ezFontColor);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
  border-style: none;
}

.ezSubContentView-no-border-no-scroll {
  background-color: var(--ezClockerWhite);
  color: var(--ezFontColor);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
  border-style: none;
  overflow: hidden;
}

.ezSubContentView-transparent-no-border-no-scroll {
  background-color: transparent;
  color: var(--ezFontColor);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
  border-style: none;
  overflow: hidden;
}

/*
    @deprecated
    Migrate to ezHtml, ezPageBody, ezPageView functionality
*/
.ezPage {
  display: grid;
  align-content: stretch;
  justify-content: stretch;
  grid-template-columns: auto;
  grid-template-rows: auto;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

/*
    @deprecated
    Migrate to ezHtml, ezPageBody, ezPageView, ezPageContent functionality
*/
.ezContent {
  display: grid;
  align-content: stretch;
  justify-content: stretch;
  grid-template-columns: auto;
  grid-template-rows: auto;
  margin-top: 4px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 0;
  overflow: scroll;
}

.ezPageFooter {
  margin-top: 20px;
  padding: 4px;
  background-color: var(--ezClockerGray);
  color: var(--ezClockerBlack);
}

.ezPageFixedFooter {
  position: fixed;
  margin-top: 20px;
  padding: 4px;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: var(--ezClockerGray);
  color: var(--ezClockerWhite);
}

.ezPageFooterLayout {
  display: grid;
  align-content: center;
  justify-content: end;
  grid-template-columns: auto;
  grid-template-rows: 100%;
  background-color: transparent;
}

/* -------------------------------------------------------------------
| Specific Grid Styles
------------------------------------------------------------------- */
.ezTimeEntryGridContainer {
  display: grid;
  align-content: stretch;
  justify-content: stretch;
  grid-template-columns: auto;
  grid-template-rows: auto;
  padding: 8px;
  margin-top: 10px;
  background-color: var(--ezAlphaBackgroundWhite2);
}

/* -------------------------------------------------------------------
| Generic Top Level Grid Styles
------------------------------------------------------------------- */
.ezFullScreen {
  display: grid;
  width: 100%;
  height: 100%;
}

.ezGridX {
  display: grid;
  color: var(--ezFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
}

.ezGridHeader {
  display: grid;
  padding: 6px;
  color: var(--ezTopicFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezTopicFontSize);
  font-weight: var(--ezTopicFontWeight);
  font-style: var(--ezTopicFontStyle);
}

.ezGridHeader-navy {
  display: grid;
  justify-content: start;
  align-content: center;
  background-color: var(--ezClockerNavy);
  color: var(--ezTopicFontColorWhite);
  font-size: var(--ezTopicFontSize);
  font-weight: var(--ezTopicFontWeight);
  font-style: var(--ezTopicFontStyle);
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
}

.ezGridContent {
  display: grid;
  padding: 4px;
  color: var(--ezContentFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezContentFontSize);
  font-weight: var(--ezContentFontWeight);
  font-style: var(--ezContentFontStyle);
}

.ezGridFullPage {
  display: grid;
  height: 100%;
}

.ezRowItem-container_2Col {
  display: grid;
  grid-template-columns: max-content auto;
  justify-content: stretch;
  align-content: center;
  grid-column-gap: 4px;
  grid-row-gap: 0;
  padding: 8px;
  background-color: var(--ezClockerWhite);
  color: var(--ezFontColor);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezTopicFontStyle);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 2px;
}

.ezRowItem-container-disabled_2Col {
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerStone);
  border-color: var(--ezClockerStone);
}

.ezRowItem-container-archived_2Col {
  display: grid;
  grid-template-rows: none;
  justify-content: stretch;
  align-content: center;
  grid-column-gap: 4px;
  grid-row-gap: 0;
  padding: 8px;
  background-color: var(--ezClockerGray);
  color: var(--ezClockerWhite);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezTopicFontStyle);
  border-color: var(--ezBorderGray);
  border-style: solid;
  border-width: 1px;
}

.ezRowItem-text_col-1of2 {
  display: grid;
  grid-column: 1/2;
  grid-row: 1;
  justify-content: start;
  align-content: center;
}

.ezRowItem-button-container_col-2of2 {
  display: grid;
  grid-template-columns: auto auto;
  grid-column: 2/2;
  grid-row: 1;
  justify-content: end;
  align-content: center;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Grid Row and Column Gap Styles
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
/* DEPRECATED */
.ezNoGridColumnGap,
.ezGridNoGap,
.ezGridGap-none {
  display: grid;
  grid-column-gap: 0;
  column-gap: 0;
}

.ezGridGap_R1_C1 {
  display: grid;
  grid-row-gap: 1px;
  grid-column-gap: 1px;
}

/* DEPRECATED */
.ezGridGap,
.ezGridGap_2,
.ezGridGap_R2_C2 {
  display: grid;
  grid-row-gap: 2px;
  grid-column-gap: 2px;
}

/* DEPRECATED */
.ezGridGap_4,
.ezGridGap_R4_C4 {
  display: grid;
  grid-row-gap: 4px;
  grid-column-gap: 4px;
}

.ezGridGap_R6_C6 {
  display: grid;
  grid-row-gap: 6px;
  grid-column-gap: 6px;
}

/* DEPRECATED */
.ezGridGap_8,
.ezGridGap_R8_C8 {
  display: grid;
  grid-row-gap: 8px;
  grid-column-gap: 8px;
}

.ezGridGap_R10_C10 {
  display: grid;
  grid-row-gap: 10px;
  grid-column-gap: 10px;
}

/* DEPRECATED */
.ezGridGap_20,
.ezGridGap_R20_C20 {
  display: grid;
  grid-row-gap: 20px;
  grid-column-gap: 20px;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Grid Row Gap Styles
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
/* DEPRECATED */
.ezGrid-row-gap-0,
.ezGrid-no-row-gap {
  display: grid;
  grid-row-gap: 0;
}

/* DEPRECATED */
.ezGridColumnGap,
.ezGrid-col-gap_1 {
  display: grid;
  grid-column-gap: 1px;
}

.ezGrid-row-gap_2 {
  display: grid;
  grid-column-gap: 2px;
}

.ezGrid-row-gap_4 {
  display: grid;
  grid-row-gap: 4px;
}

.ezGrid-row-gap_6 {
  display: grid;
  grid-row-gap: 6px;
}

.ezGrid-row-gap_8 {
  display: grid;
  grid-row-gap: 8px;
}

.ezGrid-row-gap_10 {
  display: grid;
  grid-row-gap: 10px;
}

.ezGrid-row-gap_20 {
  display: grid;
  grid-row-gap: 20px;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Grid Column Gap Styles
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
.ezGrid-col-gap_1 {
  display: grid;
  grid-column-gap: 1px;
}

.ezGrid-col-gap_2 {
  display: grid;
  grid-column-gap: 2px;
}

/* DEPRECATED */
.ezGrid-col-gap-4,
.ezGrid-col-gap_4 {
  display: grid;
  grid-column-gap: 4px;
}

.ezGrid-col-gap_6 {
  display: grid;
  grid-column-gap: 6px;
}

.ezGrid-col-gap_8 {
  display: grid;
  grid-column-gap: 8px;
}

.ezGrid-col-gap_10 {
  display: grid;
  grid-column-gap: 10px;
}

.ezGrid-col-gap_20 {
  display: grid;
  grid-column-gap: 20px;
}

/* -------------------------------------------------------------------
| Grid Text Styles
------------------------------------------------------------------- */
.ezGridContentText {
  color: var(--ezContentFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezContentFontSize);
  font-weight: var(--ezContentFontWeight);
  font-style: var(--ezContentFontStyle);
}

.ezGridRowLabelText {
  color: var(--ezFontColor);
  font-family: var(--ezFontFamily);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
  font-size: var(--ezLayoutGrid-row-label-font-size);
}

.ezGridNormalText {
  color: var(--ezFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
}

.ezGridTopicText {
  color: var(--ezClockerWhite);
  font-family: var(--ezFontFamily);
  font-size: var(--ezTopicFontSize);
  font-weight: var(--ezTopicFontWeight);
  font-style: var(--ezTopicFontStyle);
}

/* -------------------------------------------------------------------
| Grid Background Styles
------------------------------------------------------------------- */
.ezGridWhite {
  background-color: var(--ezClockerWhite);
  color: var(--ezContentFontColor);
  border-radius: 3px;
}

.ezGridBlack {
  background-color: var(--ezClockerBlack);
  color: var(--ezClockerWhite);
  border-radius: 3px;
}

.ezGridNavy {
  background-color: var(--ezNavy);
  color: var(--ezNavyContainerTextColor);
  border-radius: 3px;
}

.ezGridGray {
  background-color: var(--ezGray);
  color: var(--ezGrayContainerText);
  border-radius: 3px;
}

.ezGridStone {
  background-color: var(--ezClockerStone);
  color: var(--ezContentFontColor);
  border-radius: 3px;
}

.ezGridYellow {
  background-color: var(--ezYellow);
  color: var(--ezYelloContainerText);
  border-radius: 3px;
}

/* -------------------------------------------------------------------
| Grid Horizontal Alignment Styles (X-Axis)
------------------------------------------------------------------- */
.ezGrid-align-left {
  display: grid;
  /* X-Axis */
  justify-content: start;
}

.ezGrid-align-center {
  display: grid;
  /* X-Axis */
  justify-content: center;
}

.ezGrid-align-right {
  display: grid;
  /* X-Axis */
  justify-content: end;
}

.ezGrid-align-full {
  display: grid;
  /* X-Axis */
  justify-content: stretch;
}

.ezGrid-align-space-between {
  display: grid;
  /* X-Axis */
  justify-content: space-between;
}

.ezGrid-align-space-around {
  display: grid;
  /* X-Axis */
  justify-content: space-around;
}

.ezGrid-align-space-evenly {
  display: grid;
  /* X-Axis */
  justify-content: space-evenly;
}

/* -------------------------------------------------------------------
| Grid Vertical Alignment Styles (Y-Axis)
------------------------------------------------------------------- */
.ezGrid-vertical-align-top {
  display: grid;
  /* Y-Axis */
  align-content: start;
}

.ezGrid-vertical-align-middle {
  display: grid;
  /* Y-Axis */
  align-content: center;
}

.ezGrid-vertical-align-bottom {
  display: grid;
  /* Y-Axis */
  align-content: end;
}

.ezGrid-vertical-align-full {
  display: grid;
  /* Y-Axis */
  align-content: stretch;
}

.ezGrid-vertical-space-evenly {
  display: grid;
  /* Y-Axis */
  align-content: space-evenly;
}

.ezGrid-vertical-space-between {
  display: grid;
  /* Y-Axis */
  align-content: space-between;
}

/* -------------------------------------------------------------------
| Grid Vertical and Horizontal Alignment Styles
------------------------------------------------------------------- */
.ezGrid-fullsize {
  display: grid;
  /* X-Axis */
  align-content: stretch;
  /* Y-Axis */
  justify-content: stretch;
}

.ezGrid-align-top-left {
  display: grid;
  /* X-Axis */
  align-content: start;
  /* Y-Axis */
  justify-content: start;
}

.ezGrid-align-fullsize {
  display: grid;
  /* X-Axis */
  align-content: stretch;
  /* Y-Axis */
  justify-content: stretch;
}

.ezGrid-align-middle-full-width {
  display: grid;
  /* X-Axis */
  align-content: stretch;
  /* Y-Axis */
  justify-content: center;
}

.ezGrid-align-middle-left {
  display: grid;
  /* X-Axis */
  align-content: center;
  /* Y-Axis */
  justify-content: start;
}

.ezGrid-align-middle-right {
  display: grid;
  /* X-Axis */
  align-content: center;
  /* Y-Axis */
  justify-content: end;
}

.ezGrid-align-middle-center {
  display: grid;
  /* X-Axis */
  align-content: center;
  /* Y-Axis */
  justify-content: center;
}

.ezGrid-align-top-space-evenly {
  display: grid;
  /* X-Axis */
  align-content: start;
  /* Y-Axis */
  justify-content: space-between;
}

.ezGrid-x-space-between-y-stretch {
  display: grid;
  /* X-Axis */
  align-content: center;
  /* Y-Axis */
  justify-content: space-evenly;
}

/* -------------------------------------------------------------------
| Columns Classes for 2 Column Grids
------------------------------------------------------------------- */
.ezCol-1of2 {
  display: grid;
  grid-column: 1/2;
}

.ezCol-2of2 {
  display: grid;
  grid-column: 2/2;
}

/* -------------------------------------------------------------------
| Columns Classes for 3 Column Grids
------------------------------------------------------------------- */
.ezCol-1of3 {
  display: grid;
  grid-column: 1/2;
}

.ezCol-2of3 {
  display: grid;
  grid-column: 2/2;
}

.ezCol-3of3 {
  display: grid;
  grid-column: 3/3;
}

/* -------------------------------------------------------------------
| Columns Classes for 4 Column Grids
------------------------------------------------------------------- */
.ezCol-1of4 {
  display: grid;
  grid-column: 1/4;
}

.ezCol-2of4 {
  display: grid;
  grid-column: 2/4;
}

.ezCol-3of4 {
  display: grid;
  grid-column: 3/4;
}

.ezCol-4of4 {
  display: grid;
  grid-column: 3/4;
}

/* -------------------------------------------------------------------
| Generic Row Grid Styles
------------------------------------------------------------------- */
.ezAutoRow {
  display: grid;
  grid-template-rows: auto;
}

.ezAutoRow_Min {
  display: grid;
  grid-template-rows: min-content;
}

.ezAutoRow_100 {
  display: grid;
  grid-template-rows: 100%;
}

/* -------------------------------------------------------------------
| Two Row Grid Styles
------------------------------------------------------------------- */
.ezAutoRow_Min_2 {
  display: grid;
  grid-template-rows: min-content min-content;
}

.ezAutoRow_Min_Auto {
  display: grid;
  grid-template-rows: min-content auto;
}

.ezAutoRow_MinxMax,
.ezAutoRow_Min_Max {
  display: grid;
  grid-template-rows: min-content max-content;
}

.ezAutoRow_600px_600px {
  display: grid;
  grid-template-columns: 600px 600px;
}

.ezAutoRow_Min_Min {
  display: grid;
  grid-template-rows: min-content min-content;
}

.ezAutoRow_A_Max {
  display: grid;
  grid-template-rows: auto max-content;
}

.ezAutoRow_A_min {
  display: grid;
  grid-template-rows: auto min-content;
}

.ezAutoRow_AxA,
.ezAutoRow_A_A {
  display: grid;
  grid-template-rows: auto auto;
}

.ezAutoRow_50_A {
  display: grid;
  grid-template-rows: 50% auto;
}

.ezAutoRow_A_50 {
  display: grid;
  grid-template-rows: auto 50%;
}

.ezAutoRow_50x50,
.ezAutoRow_50_50 {
  display: grid;
  grid-template-rows: 50% 50%;
}

/* -------------------------------------------------------------------
| Three Row Grid Styles
------------------------------------------------------------------- */
.ezAutoRow_Min_3 {
  display: grid;
  grid-template-rows: min-content min-content min-content;
}

.ezAutoRow_A_A_A {
  display: grid;
  grid-template-rows: auto auto auto;
}

.ezAutoRow_33_A_33 {
  display: grid;
  grid-template-rows: 33% auto 33%;
}

.ezAutoRow_33_33_33 {
  display: grid;
  grid-template-rows: 33% 33% 33%;
}

.ezAutoRow_33_33_A {
  display: grid;
  grid-template-rows: 33% 33% auto;
}

.ezAutoRow_A_33_33 {
  display: grid;
  grid-template-rows: auto 33% 33%;
}

.ezAutoRow_25_A_25 {
  display: grid;
  grid-template-rows: 25% auto 25%;
}

.ezAutoRow_25_50_25 {
  display: grid;
  grid-template-rows: 25% 50% 25%;
}

.ezAutoRow_25_25_A {
  display: grid;
  grid-template-rows: 25% 25% auto;
}

.ezAutoRow_A_25_25 {
  display: grid;
  grid-template-rows: auto 25% 25%;
}

.ezAutoRow_1fr_2fr_1fr {
  display: grid;
  grid-template-rows: 1fr 2fr 1fr;
}

.ezAutoRow_Min_Max_A {
  display: grid;
  grid-template-rows: min-content, max-content, auto;
}

/* -------------------------------------------------------------------
| Four Row Grid Styles
------------------------------------------------------------------- */
.ezAutoRow_AxAxAxA {
  display: grid;
  grid-template-rows: auto auto auto auto;
}

/* -------------------------------------------------------------------
| Five Row Grid Styles
------------------------------------------------------------------- */
.ezAutoRow_AxAxAxAxA {
  display: grid;
  grid-template-rows: auto auto auto auto auto;
}

/* -------------------------------------------------------------------
| One Column Grid Styles
------------------------------------------------------------------- */
.ezAutoCol_A {
  display: grid;
  grid-template-columns: auto;
}

.ezAutoCol_100 {
  display: grid;
  grid-template-columns: 100%;
}

.ezAutoCol_99 {
  display: grid;
  grid-template-columns: 99%;
}

/* -------------------------------------------------------------------
| Two (TWO! HA HA HA!) Column Grid Styles
------------------------------------------------------------------- */
.ezAutoCol_83xA {
  grid-template-columns: 83.33333333% auto;
}

.ezAutoCol_MinxA {
  display: grid;
  grid-template-columns: min-content auto;
}

.ezAutoCol_AxMin {
  display: grid;
  grid-template-columns: auto min-content;
}

.ezAutoCol_AxMax {
  display: grid;
  grid-template-columns: auto max-content;
}

.ezAutoCol_MinxMax {
  display: grid;
  grid-template-columns: min-content max-content;
}

.ezAutoCol_Max_Min {
  display: grid;
  grid-template-columns: max-content min-content;
}

.ezAutoCol_Max_A {
  display: grid;
  grid-template-columns: max-content min-content;
}

.ezAutoCol_Max_Max {
  display: grid;
  grid-template-columns: max-content max-content;
}

.ezAutoCol_AxA {
  display: grid;
  grid-template-columns: auto auto;
}

.ezAutoCol_50xA {
  display: grid;
  grid-template-columns: 50% auto;
}

.ezAutoCol_Ax70 {
  display: grid;
  grid-template-columns: auto 70%;
}

.ezAutoCol_Ax50 {
  display: grid;
  grid-template-columns: auto 50%;
}

.ezAutoCol_50x50 {
  display: grid;
  grid-template-columns: 50% 50%;
}

.ezAutoCol_200PXxA {
  display: grid;
  grid-template-columns: 200px auto;
}

.ezAutoCol_33xA {
  display: grid;
  grid-template-columns: 33% auto;
}

.ezAutoCol_Ax33 {
  display: grid;
  grid-template-columns: auto 33%;
}

.ezAutoCol_25xA {
  display: grid;
  grid-template-columns: 25% auto;
}

.ezAutoCol_Ax25 {
  display: grid;
  grid-template-columns: auto 25%;
}

.ezAutoCol_75xA {
  display: grid;
  grid-template-columns: 75% auto;
}

/* -------------------------------------------------------------------
| Three (THREE! HA HA HA!) Column Grid Styles
------------------------------------------------------------------- */
.ezAutoCol_28px_28px_28px {
  display: grid;
  grid-template-columns: 28px 28px 28px;
}

.ezAutoCol_MinxMinxMin {
  display: grid;
  grid-template-columns: min-content min-content min-content;
}

.ezAutoCol_AxAxMin {
  display: grid;
  grid-template-columns: auto auto min-content;
}

.ezAutoCol_AxAxA {
  display: grid;
  grid-template-columns: auto auto auto;
}

.ezAutoCol_25x25xA {
  display: grid;
  grid-template-columns: 25% 25% auto;
}

.ezAutoCol_25xAx25 {
  display: grid;
  grid-template-columns: 25% auto 25%;
}

.ezAutoCol_Ax25x25 {
  display: grid;
  grid-template-columns: auto 25% 25%;
}

.ezAutoCol_33x33xA {
  display: grid;
  grid-template-columns: 33% 33% auto;
}

.ezAutoCol_33xAx33 {
  display: grid;
  grid-template-columns: 33% auto 33%;
}

.ezAutoCol_Ax33x33 {
  display: grid;
  grid-template-columns: auto 33% 33%;
}

.ezAutoCol_33x33x33 {
  display: grid;
  grid-template-columns: 33% 33% 33%;
}

.ezAutoCol_50x25xA {
  display: grid;
  grid-template-columns: 25% 25% auto;
}

.ezAutoCol_Ax50x25 {
  display: grid;
  grid-template-columns: auto 50% 25%;
}

.ezAutoCol_50xAx25 {
  display: grid;
  grid-template-columns: 50% auto 25%;
}

.ezAutoCol_50xAxA {
  display: grid;
  grid-template-columns: 50% auto auto;
}

.ezAutoCol_Ax50xA {
  display: grid;
  grid-template-columns: auto 50% auto;
}

.ezAutoCol_AxAx50 {
  display: grid;
  grid-template-columns: auto auto 50%;
}

.ezAutoCol_AxAx30px {
  display: grid;
  grid-template-columns: auto auto 33px;
}

.ezAutoCol_Ax75xA {
  display: grid;
  grid-template-columns: auto 75% auto;
}

/* -------------------------------------------------------------------
| Four (FOUR! HA HA HA!) Column Grid Styles
------------------------------------------------------------------- */
.ezAutoCol_AxAxAxA {
  display: grid;
  grid-template-columns: auto auto auto auto;
}

.ezAutoCol_25x25xAxA {
  display: grid;
  grid-template-columns: 25% 25% auto auto;
}

.ezAutoCol_25x25x25xA {
  display: grid;
  grid-template-columns: 25% 25% 25% auto;
}

.ezAutoCol_25xAxAx25 {
  display: grid;
  grid-template-columns: 25% auto auto 25%;
}

.ezAutoCol_AxAxAx25 {
  display: grid;
  grid-template-columns: auto auto auto 25%;
}

.ezAutoCol_10xAxAx10 {
  display: grid;
  grid-template-columns: 10% auto auto 10%;
}

.ezAutoCol_AxAxAxMax {
  display: grid;
  grid-template-columns: auto auto auto max-content;
}

/* -------------------------------------------------------------------
| Five (FIVE! MUHAHAHAHA!) Column Grid Styles
------------------------------------------------------------------- */
.ezAutoCol_AxAxAxAxA {
  display: grid;
  grid-template-columns: auto auto auto auto auto;
}

/* Column Spans */
.ezColSpan_1a2 {
  display: grid;
  grid-column-start: 1;
  grid-column-end: 2;
}

.ezColSpan_1a2a3 {
  display: grid;
  grid-column-start: 1;
  grid-column-end: 3;
}

.ezColSpan_2a3 {
  display: grid;
  grid-column-start: 2;
  grid-column-end: 3;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Sub-Grid Styles
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
.ezSubGridColRow {
  display: grid;
  grid-template-columns: subgrid;
  grid-template-rows: subgrid;
}

.ezSubgridRow {
  display: grid;
  grid-template-rows: subgrid;
}

.ezSubGridCol {
  display: grid;
  grid-template-columns: subgrid;
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 1024px) {
}
*/
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 768px) {
}
*/
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 480px) {
}/

/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 319px) {
}
*/
/* -------------------------------------------------------------------
| DEPRECATED STYLES
------------------------------------------------------------------- */
/* DEPRECATED */
.ezPadTop2 {
  padding-top: 2px;
}

/* DEPRECATED */
.ezPadBottom2 {
  padding-bottom: 2px;
}

/* DEPRECATED */
.ezPadTopBottom2 {
  padding-top: 2px;
  padding-bottom: 2px;
}

/* DEPRECATED */
.ezPadLeft2 {
  padding-left: 2px;
}

/* DEPRECATED */
.ezPadRight2 {
  padding-right: 2px;
}

/* DEPRECATED */
.ezPadLeftRight2 {
  padding-left: 2px;
  padding-right: 2px;
}

/* DEPRECATED */
.ezPaddedBox4 {
  padding: 4px;
}

/* DEPRECATED */
.ezPadTop4 {
  padding-top: 4px;
}

/* DEPRECATED */
.ezPadBottom4 {
  padding-bottom: 4px;
}

/* DEPRECATED */
.ezPadTopBottom4 {
  padding-top: 4px;
  padding-bottom: 4px;
}

/* DEPRECATED */
.ezPadLeft4 {
  padding-left: 4px;
}

/* DEPRECATED */
.ezPadRight4 {
  padding-right: 4px;
}

/* DEPRECATED */
.ezPadLeftRight4 {
  padding-left: 4px;
  padding-right: 4px;
}

/* DEPRECATED */
.ezPadTop6 {
  padding-top: 6px;
}

/* DEPRECATED */
.ezPadBottom6 {
  padding-bottom: 6px;
}

/* DEPRECATED */
.ezPadTopBottom6 {
  padding-top: 6px;
  padding-bottom: 6px;
}

/* DEPRECATED */
.ezPadLeft6 {
  padding-left: 6px;
}

/* DEPRECATED */
.ezPadRight6 {
  padding-right: 6px;
}

/* DEPRECATED */
.ezPadLeftRight6 {
  padding-left: 6px;
  padding-right: 6px;
}

/* DEPRECATED */
.ezPadTop8 {
  padding-top: 8px;
}

/* DEPRECATED */
.ezPadBottom8 {
  padding-bottom: 8px;
}

/* DEPRECATED */
.ezPadTopBottom8 {
  padding-top: 8px;
  padding-bottom: 8px;
}

/* DEPRECATED */
.ezPadLeft8 {
  padding-left: 8px;
}

/* DEPRECATED */
.ezPadRight8 {
  padding-right: 8px;
}

/* DEPRECATED */
.ezPadLeftRight8 {
  padding-left: 8px;
  padding-right: 8px;
}

/* DEPRECATED */
.ezPadTop10 {
  padding-top: 10px;
}

/* DEPRECATED */
.ezPadBottom10 {
  padding-bottom: 10px;
}

/* DEPRECATED */
.ezPadTopBottom10 {
  padding-top: 10px;
  padding-bottom: 10px;
}

/* DEPRECATED */
.ezPadLeft10 {
  padding-left: 10px;
}

/* DEPRECATED */
.ezPadRight10 {
  padding-right: 10px;
}

/* DEPRECATED */
.ezPadLeftRight10 {
  padding-left: 10px;
  padding-right: 10px;
}

/* DEPRECATED */
.ezMargin2 {
  margin: 2px;
}

/* DEPRECATED */
.ezMarginTop2 {
  margin-top: 2px;
}

/* DEPRECATED */
.ezMarginBottom2 {
  margin-bottom: 2px;
}

/* DEPRECATED */
.ezMarginTopBottom2 {
  margin-top: 2px;
  margin-bottom: 2px;
}

/* DEPRECATED */
.ezMarginLeft2 {
  margin-left: 2px;
}

/* DEPRECATED */
.ezMarginRight2 {
  margin-right: 2px;
}

/* DEPRECATED */
.ezMarginLeftRight2 {
  margin-left: 2px;
  margin-right: 2px;
}

/* DEPRECATED */
.ezMargin4 {
  margin: 4px;
}

/* DEPRECATED */
.ezMarginTop4 {
  margin-top: 4px;
}

/* DEPRECATED */
.ezMarginBottom4 {
  margin-bottom: 4px;
}

/* DEPRECATED */
.ezMarginTopBottom4 {
  margin-top: 4px;
  margin-bottom: 4px;
}

/* DEPRECATED */
.ezMarginLeft4 {
  margin-left: 4px;
}

/* DEPRECATED */
.ezMarginRight4 {
  margin-right: 4px;
}

/* DEPRECATED */
.ezMarginLeftRight4 {
  margin-left: 4px;
  margin-right: 4px;
}

/* DEPRECATED */
.ezMargin8 {
  margin: 8px;
}

/* DEPRECATED */
.ezMarginTop8 {
  margin-top: 8px;
}

/* DEPRECATED */
.ezMarginBottom8 {
  margin-bottom: 8px;
}

/* DEPRECATED */
.ezMarginTopBottom8 {
  margin-top: 8px;
  margin-bottom: 8px;
}

/* DEPRECATED */
.ezMarginLeft8 {
  margin-left: 8px;
}

/* DEPRECATED */
.ezMarginRight8 {
  margin-right: 8px;
}

/* DEPRECATED */
.ezMarginLeftRight8 {
  margin-left: 8px;
  margin-right: 8px;
}

/* DEPRECATED */
.ezMargin10 {
  margin: 10px;
}

/* DEPRECATED */
.ezMarginTop10 {
  margin-top: 10px;
}

/* DEPRECATED */
.ezMarginBottom10 {
  margin-bottom: 10px;
}

/* DEPRECATED */
.ezMarginTopBottom10 {
  margin-top: 10px;
  margin-bottom: 10px;
}

/* DEPRECATED */
.ezMarginLeft10 {
  margin-left: 10px;
}

/* DEPRECATED */
.ezMarginRight10 {
  margin-right: 10px;
}

/* DEPRECATED */
.ezMarginLeftRight10 {
  margin-left: 10px;
  margin-right: 10px;
}

/* -------------------------------------------------------------------
| Legacy Auto-Column (experimental) Styles
------------------------------------------------------------------- */
/* DEPRECATED */
.ezAutoCol1 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 8.33333333%;
}

/* DEPRECATED */
.ezAutoCol2 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 16.66666667%;
}

/* DEPRECATED */
.ezAutoCol3 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 25%;
}

/* DEPRECATED */
.ezAutoCol4 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 33.33333333%;
}

/* DEPRECATED */
.ezAutoCol5 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 41.66666667%;
}

/* DEPRECATED */
.ezAutoCol6 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 50%;
}

/* DEPRECATED */
.ezAutoCol7 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 58.33333333%;
}

/* DEPRECATED */
.ezAutoCol8 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 66.66666667%;
}

/* DEPRECATED */
.ezAutoCol9 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 75%;
}

/* DEPRECATED */
.ezAutoCol10 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 83.33333333%;
}

/* DEPRECATED */
.ezAutoCol11 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 91.66666667%;
}

/* DEPRECATED */
.ezColumn12 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 100%;
}

/* DEPRECATED */
.ezCenterBox {
  display: flex;
  text-align: right;
  flex-direction: column;
  align-items: center;
}

/* DEPRECATED */
.ezBox {
  display: inline-block;
}

/* DEPRECATED */
.ezFooter {
  padding: 4px;
  height: 24px;
  bottom: 0;
  background-color: var(--ezClockerSilver);
}

/* DEPRECATED */
.ezRightAlign {
  text-align: right;
}

/* DEPRECATED */
td.ezclockerHeader2015Right {
  vertical-align: middle;
  text-align: right;
}

/* DEPRECATED */
.ezInfoBox {
  padding: 4px;
  background-color: var(--ezClockerInfoYellow);
  color: var(--ezClockerBlack);
  border-style: solid;
  border-color: var(--ezDarkYellow);
  border-width: 1px;
}

/* DEPRECATED */
.ezCell {
  padding: 4px;
  background-color: transparent;
  color: var(--ezFontColor);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
  border-style: solid;
  border-color: var(--ezClockerGray);
  border-width: 1px;
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-layout-grid.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,2BAAA;EACA,wCAAA;AAAJ;;AAGA;;qEAAA;AAGA;EACI,YAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;AAAJ;;AAGA;EACI,uCAAA;EACA,4BAAA;AAAJ;;AAGA;EACI,eAAA;EACA,MAAA;EACA,WAAA;AAAJ;;AAGA;EACI,aAAA;EACA,oBAAA;EACA,+BAAA;EACA,iCAAA;EACA,gDAAA;EACA,6CAAA;EACA,0CAAA;EACA,gCAAA;EACA,mCAAA;EACA,gCAAA;EACA,uCAAA;EACA,qCAAA;AAAJ;;AAGA;EACI,aAAA;EACA,oBAAA;EACA,+BAAA;EACA,iCAAA;EACA,gDAAA;EACA,6CAAA;EACA,0CAAA;EACA,gCAAA;EACA,mCAAA;EACA,gCAAA;EACA,uCAAA;EACA,qCAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,6BAAA;AAAJ;;AAGA;EACI,aAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,6BAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,oBAAA;EACA,2BAAA;EACA,6BAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,2BAAA;EACA,6BAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,6BAAA;EACA,cAAA;AAAJ;;AAGA;EACI,SAAA;EACA,UAAA;EACA,6BAAA;AAAJ;;AAGA;EACI,SAAA;EACA,UAAA;EACA,6BAAA;EACA,kBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;AAAJ;;AAGA;EACI,SAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,kBAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,UAAA;EACA,sBAAA;EACA,wBAAA;EACA,6BAAA;EACA,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,YAAA;EACA,sBAAA;EACA,wBAAA;EACA,uCAAA;EACA,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,uCAAA;EACA,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,YAAA;EACA,uCAAA;EACA,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,YAAA;EACA,uCAAA;EACA,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,uCAAA;EACA,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,6BAAA;EACA,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;AAAJ;;AAGA;;;CAAA;AAIA;EACI,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,2BAAA;EACA,wBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AAAJ;;AAGA;;;CAAA;AAIA;EACI,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,2BAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,YAAA;EACA,sCAAA;EACA,4BAAA;AAAJ;;AAGA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,sCAAA;EACA,4BAAA;AAAJ;;AAGA;EACI,aAAA;EACA,qBAAA;EACA,oBAAA;EACA,2BAAA;EACA,wBAAA;EACA,6BAAA;AAAJ;;AAGA;;qEAAA;AAGA;EACI,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,2BAAA;EACA,wBAAA;EACA,YAAA;EACA,gBAAA;EACA,gDAAA;AAAJ;;AAIA;;qEAAA;AAGA;EACI,aAAA;EACA,WAAA;EACA,YAAA;AADJ;;AAIA;EACI,aAAA;EACA,yBAAA;EACA,gCAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;AADJ;;AAIA;EACI,aAAA;EACA,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;AADJ;;AAIA;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,sCAAA;EACA,mCAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,aAAA;EACA,YAAA;EACA,gCAAA;EACA,gCAAA;EACA,mCAAA;EACA,uCAAA;EACA,qCAAA;AADJ;;AAIA;EACI,aAAA;EACA,YAAA;AADJ;;AAIA;EACI,aAAA;EACA,uCAAA;EACA,wBAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,YAAA;EACA,uCAAA;EACA,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,mCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,uCAAA;EACA,4BAAA;EACA,mCAAA;AADJ;;AAIA;EACI,aAAA;EACA,wBAAA;EACA,wBAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,4BAAA;EACA,gCAAA;EACA,mCAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,aAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,qBAAA;AADJ;;AAIA;EACI,aAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;AADJ;;AAKA;;;;EAAA;AAMA,eAAA;AACA;;;EAII,aAAA;EACA,kBAAA;EACA,aAAA;AAJJ;;AAOA;EACI,aAAA;EACA,iBAAA;EACA,oBAAA;AAJJ;;AAOA,eAAA;AACA;;;EAII,aAAA;EACA,iBAAA;EACA,oBAAA;AALJ;;AAQA,eAAA;AACA;;EAEI,aAAA;EACA,iBAAA;EACA,oBAAA;AALJ;;AAQA;EACI,aAAA;EACA,iBAAA;EACA,oBAAA;AALJ;;AAQA,eAAA;AACA;;EAEI,aAAA;EACA,iBAAA;EACA,oBAAA;AALJ;;AAQA;EACI,aAAA;EACA,kBAAA;EACA,qBAAA;AALJ;;AAQA,eAAA;AACA;;EAEI,aAAA;EACA,kBAAA;EACA,qBAAA;AALJ;;AASA;;;;EAAA;AAMA,eAAA;AACA;;EAEI,aAAA;EACA,eAAA;AAPJ;;AAUA,eAAA;AACA;;EAEI,aAAA;EACA,oBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,oBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,iBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,iBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,iBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,kBAAA;AAPJ;;AAWA;;;;EAAA;AAMA;EACI,aAAA;EACA,oBAAA;AATJ;;AAYA;EACI,aAAA;EACA,oBAAA;AATJ;;AAYA,eAAA;AACA;;EAEI,aAAA;EACA,oBAAA;AATJ;;AAYA;EACI,aAAA;EACA,oBAAA;AATJ;;AAYA;EACI,aAAA;EACA,oBAAA;AATJ;;AAYA;EACI,aAAA;EACA,qBAAA;AATJ;;AAYA;EACI,aAAA;EACA,qBAAA;AATJ;;AAgBA;;qEAAA;AAGA;EACI,gCAAA;EACA,gCAAA;EACA,mCAAA;EACA,uCAAA;EACA,qCAAA;AAbJ;;AAgBA;EACI,yBAAA;EACA,gCAAA;EACA,gCAAA;EACA,8BAAA;EACA,kDAAA;AAbJ;;AAgBA;EACI,yBAAA;EACA,gCAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;AAbJ;;AAgBA;EACI,4BAAA;EACA,gCAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;AAbJ;;AAiBA;;qEAAA;AAGA;EACI,uCAAA;EACA,gCAAA;EACA,kBAAA;AAdJ;;AAiBA;EACI,uCAAA;EACA,4BAAA;EACA,kBAAA;AAdJ;;AAiBA;EACI,+BAAA;EACA,sCAAA;EACA,kBAAA;AAdJ;;AAiBA;EACI,+BAAA;EACA,iCAAA;EACA,kBAAA;AAdJ;;AAiBA;EACI,uCAAA;EACA,gCAAA;EACA,kBAAA;AAdJ;;AAiBA;EACI,iCAAA;EACA,kCAAA;EACA,kBAAA;AAdJ;;AAkBA;;qEAAA;AAGA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;AAfJ;;AAkBA;EACI,aAAA;EACA,WAAA;EACA,uBAAA;AAfJ;;AAkBA;EACI,aAAA;EACA,WAAA;EACA,oBAAA;AAfJ;;AAkBA;EACI,aAAA;EACA,WAAA;EACA,wBAAA;AAfJ;;AAkBA;EACI,aAAA;EACA,WAAA;EACA,8BAAA;AAfJ;;AAkBA;EACI,aAAA;EACA,WAAA;EACA,6BAAA;AAfJ;;AAkBA;EACI,aAAA;EACA,WAAA;EACA,6BAAA;AAfJ;;AAmBA;;qEAAA;AAGA;EACI,aAAA;EACA,WAAA;EACA,oBAAA;AAhBJ;;AAmBA;EACI,aAAA;EACA,WAAA;EACA,qBAAA;AAhBJ;;AAmBA;EACI,aAAA;EACA,WAAA;EACA,kBAAA;AAhBJ;;AAmBA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;AAhBJ;;AAmBA;EACI,aAAA;EACA,WAAA;EACA,2BAAA;AAhBJ;;AAmBA;EACI,aAAA;EACA,WAAA;EACA,4BAAA;AAhBJ;;AAoBA;;qEAAA;AAGA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,wBAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,sBAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,wBAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,uBAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;EACA,sBAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;EACA,oBAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;EACA,uBAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,8BAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;EACA,6BAAA;AAjBJ;;AAoBA;;qEAAA;AAGA;EACI,aAAA;EACA,gBAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,gBAAA;AAjBJ;;AAoBA;;qEAAA;AAGA;EACI,aAAA;EACA,gBAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,gBAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,gBAAA;AAjBJ;;AAoBA;;qEAAA;AAGA;EACI,aAAA;EACA,gBAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,gBAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,gBAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,gBAAA;AAjBJ;;AAoBA;;qEAAA;AAGA;EACI,aAAA;EACA,wBAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,+BAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,wBAAA;AAjBJ;;AAoBA;;qEAAA;AAGA;EACI,aAAA;EACA,2CAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,oCAAA;AAjBJ;;AAoBA;;EAEI,aAAA;EACA,2CAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,kCAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,2CAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,oCAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,oCAAA;AAjBJ;;AAoBA;;EAEI,aAAA;EACA,6BAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,4BAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,4BAAA;AAjBJ;;AAoBA;;EAEI,aAAA;EACA,2BAAA;AAjBJ;;AAoBA;;qEAAA;AAGA;EACI,aAAA;EACA,uDAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,kCAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,gCAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,+BAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,gCAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,gCAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,gCAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,+BAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,gCAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,gCAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,+BAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,kDAAA;AAjBJ;;AAoBA;;qEAAA;AAGA;EACI,aAAA;EACA,uCAAA;AAjBJ;;AAoBA;;qEAAA;AAGA;EACI,aAAA;EACA,4CAAA;AAjBJ;;AAoBA;;qEAAA;AAGA;EACI,aAAA;EACA,2BAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,2BAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,0BAAA;AAjBJ;;AAqBA;;qEAAA;AAGA;EACI,wCAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,uCAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,uCAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,uCAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,8CAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,8CAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,8CAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,8CAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,gCAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,+BAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,+BAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,+BAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,8BAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,iCAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,+BAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,+BAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,+BAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,+BAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,+BAAA;AAlBJ;;AAsBA;;qEAAA;AAGA;EACI,aAAA;EACA,qCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,0DAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,4CAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,qCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,mCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,mCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,mCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,mCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,mCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,mCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,kCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,mCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,mCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,mCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,oCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,oCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,oCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,qCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,oCAAA;AAnBJ;;AAsBA;;qEAAA;AAGA;EACI,aAAA;EACA,0CAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,wCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,uCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,wCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,yCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,wCAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,iDAAA;AAnBJ;;AAsBA;;qEAAA;AAGA;EACI,aAAA;EACA,+CAAA;AAnBJ;;AAsBA,iBAAA;AACA;EACI,aAAA;EACA,oBAAA;EACA,kBAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,oBAAA;EACA,kBAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,oBAAA;EACA,kBAAA;AAnBJ;;AAuBA;;;;EAAA;AAMA;EACI,aAAA;EACA,8BAAA;EACA,2BAAA;AArBJ;;AAwBA;EACI,aAAA;EACA,2BAAA;AArBJ;;AAwBA;EACI,aAAA;EACA,8BAAA;AArBJ;;AAyBA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;;;;qEAAA;AAOA;;;CAAA;AAKA;;qEAAA;AAIA,eAAA;AACA;EACI,gBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,mBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,gBAAA;EACA,mBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,iBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,kBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,iBAAA;EACA,kBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,YAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,gBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,mBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,gBAAA;EACA,mBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,iBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,kBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,iBAAA;EACA,kBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,gBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,mBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,gBAAA;EACA,mBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,iBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,kBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,iBAAA;EACA,kBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,gBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,mBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,gBAAA;EACA,mBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,iBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,kBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,iBAAA;EACA,kBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,iBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,oBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,iBAAA;EACA,oBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,kBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,mBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,kBAAA;EACA,mBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,WAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,eAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,kBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,eAAA;EACA,kBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,gBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,iBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,gBAAA;EACA,iBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,WAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,eAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,kBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,eAAA;EACA,kBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,gBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,iBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,gBAAA;EACA,iBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,WAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,eAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,kBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,eAAA;EACA,kBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,gBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,iBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,gBAAA;EACA,iBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,YAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,gBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,mBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,gBAAA;EACA,mBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,iBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,kBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,iBAAA;EACA,kBAAA;AA1BJ;;AA6BA;;qEAAA;AAGA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,kCAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,mCAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,0BAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,mCAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,mCAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,0BAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,mCAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,mCAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,0BAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,mCAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,mCAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,2BAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,qBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,YAAA;EACA,YAAA;EACA,SAAA;EACA,wCAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,iBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,sBAAA;EACA,iBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,YAAA;EACA,4CAAA;EACA,4BAAA;EACA,mBAAA;EACA,iCAAA;EACA,iBAAA;AA1BJ;;AA6BA,eAAA;AACA;EACI,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;EACA,mBAAA;EACA,kCAAA;EACA,iBAAA;AA1BJ","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| EzClocker Grid Layout UX CSS Classes\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n\n:root {\n    /* ezClocker Font Famlies */\n    --ezLayoutGrid-row-label-font-size: 12pt;\n}\n\n/* -------------------------------------------------------------------\n| Page Grid Layout Styles\n------------------------------------------------------------------- */\n.ezHtml {\n    width: 100vw;\n    height: 100vh;\n    margin: 0;\n    padding: 0;\n}\n\n.ezPageHeader {\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);\n}\n\n.ezFixedPageHeader {\n    position: fixed;\n    top: 0;\n    width: 100%;\n}\n\n.ezPageBody {\n    display: grid;\n    align-content: start;\n    margin: var(--ezBodyMarginSize);\n    padding: var(--ezBodyPaddingSize);\n    background-color: var(--ezAlphaBackgroundWhite1);\n    background-size: var(--ezBackgroundImageSize);\n    background-image: var(--ezBackgroundImage);\n    color: var(--ezContentFontColor);\n    font-size: var(--ezContentFontSize);\n    font-family: var(--ezFontFamily);\n    font-weight: var(--ezContentFontWeight);\n    font-style: var(--ezContentFontStyle);\n}\n\n.ezPageBody-no-scroll {\n    display: grid;\n    align-content: start;\n    margin: var(--ezBodyMarginSize);\n    padding: var(--ezBodyPaddingSize);\n    background-color: var(--ezAlphaBackgroundWhite1);\n    background-size: var(--ezBackgroundImageSize);\n    background-image: var(--ezBackgroundImage);\n    color: var(--ezContentFontColor);\n    font-size: var(--ezContentFontSize);\n    font-family: var(--ezFontFamily);\n    font-weight: var(--ezContentFontWeight);\n    font-style: var(--ezContentFontStyle);\n    overflow: hidden;\n}\n\n.ezPageView {\n    display: grid;\n    margin: 0;\n    padding: 0;\n    align-content: start;\n    background-color: transparent;\n}\n\n.ezPageView-no-scroll {\n    display: grid;\n    margin: 0;\n    padding: 0;\n    align-content: start;\n    background-color: transparent;\n    overflow: hidden;\n}\n\n.ezPageViewHeader {\n    display: grid;\n    align-content: start;\n    grid-template-columns: 100%;\n    background-color: transparent;\n    overflow: hidden;\n}\n\n.ezPageSection {\n    display: grid;\n    padding: 0;\n    margin: 0;\n    align-content: start;\n    grid-template-columns: 100%;\n    background-color: transparent;\n    overflow: hidden;\n}\n\n.ezContentView {\n    margin-top: 4px;\n    margin-left: 10px;\n    margin-right: 10px;\n    padding: 0;\n    background-color: transparent;\n    overflow: auto;\n}\n\n.ezContentSection {\n    margin: 0;\n    padding: 0;\n    background-color: transparent;\n}\n\n.ezContentSection-vertical-scroll {\n    margin: 0;\n    padding: 0;\n    background-color: transparent;\n    overflow-y: scroll;\n    overflow-x: hidden;\n}\n\n.ezContent-grid-col-section-50x50 {\n    display: grid;\n    margin: 0;\n    padding: 0;\n    grid-row-gap: 0;\n    grid-column-gap: 4px;\n    grid-template-columns: 50% 50%;\n    background-color: transparent;\n}\n\n.ezContentSection-inset-border-2-radius-bottom-pad4-vscroll {\n    margin: 0;\n    padding: 4px;\n    background-color: transparent;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    border-color: var(--ezClockerBlack);\n    border-style: solid;\n    border-width: 2px;\n    border-radius: 3px;\n}\n\n.ezBorderlessSubContentView {\n    display: grid;\n    padding: 0;\n    align-content: stretch;\n    justify-content: stretch;\n    background-color: transparent;\n    color: var(--ezFontColor);\n    font-size: var(--ezFontSize);\n    font-weight: var(--ezFontWeight);\n    font-style: var(--ezFontStyle);\n    border-style: none;\n}\n\n.ezSubContentView {\n    display: grid;\n    padding: 8px;\n    align-content: stretch;\n    justify-content: stretch;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezFontColor);\n    font-size: var(--ezFontSize);\n    font-weight: var(--ezFontWeight);\n    font-style: var(--ezFontStyle);\n    border-color: var(--ezClockerSilver);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezSubContentView-no-scroll {\n    background-color: var(--ezClockerWhite);\n    color: var(--ezFontColor);\n    font-size: var(--ezFontSize);\n    font-weight: var(--ezFontWeight);\n    font-style: var(--ezFontStyle);\n    border-color: var(--ezClockerSilver);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    overflow: hidden;\n}\n\n.ezSubContentView_vertical {\n    padding: 8px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezFontColor);\n    font-size: var(--ezFontSize);\n    font-weight: var(--ezFontWeight);\n    font-style: var(--ezFontStyle);\n    border-color: var(--ezClockerSilver);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezSubContentView-no-border {\n    padding: 8px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezFontColor);\n    font-size: var(--ezFontSize);\n    font-weight: var(--ezFontWeight);\n    font-style: var(--ezFontStyle);\n    border-style: none;\n}\n\n.ezSubContentView-no-border-no-scroll {\n    background-color: var(--ezClockerWhite);\n    color: var(--ezFontColor);\n    font-size: var(--ezFontSize);\n    font-weight: var(--ezFontWeight);\n    font-style: var(--ezFontStyle);\n    border-style: none;\n    overflow: hidden;\n}\n\n.ezSubContentView-transparent-no-border-no-scroll {\n    background-color: transparent;\n    color: var(--ezFontColor);\n    font-size: var(--ezFontSize);\n    font-weight: var(--ezFontWeight);\n    font-style: var(--ezFontStyle);\n    border-style: none;\n    overflow: hidden;\n}\n\n/*\n    @deprecated\n    Migrate to ezHtml, ezPageBody, ezPageView functionality\n*/\n.ezPage {\n    display: grid;\n    align-content: stretch;\n    justify-content: stretch;\n    grid-template-columns: auto;\n    grid-template-rows: auto;\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n}\n\n/*\n    @deprecated\n    Migrate to ezHtml, ezPageBody, ezPageView, ezPageContent functionality\n*/\n.ezContent {\n    display: grid;\n    align-content: stretch;\n    justify-content: stretch;\n    grid-template-columns: auto;\n    grid-template-rows: auto;\n    margin-top: 4px;\n    margin-left: 10px;\n    margin-right: 10px;\n    padding: 0;\n    overflow: scroll;\n}\n\n.ezPageFooter {\n    margin-top: 20px;\n    padding: 4px;\n    background-color: var(--ezClockerGray);\n    color: var(--ezClockerBlack);\n}\n\n.ezPageFixedFooter {\n    position: fixed;\n    margin-top: 20px;\n    padding: 4px;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    background-color: var(--ezClockerGray);\n    color: var(--ezClockerWhite);\n}\n\n.ezPageFooterLayout {\n    display: grid;\n    align-content: center;\n    justify-content: end;\n    grid-template-columns: auto;\n    grid-template-rows: 100%;\n    background-color: transparent;\n}\n\n/* -------------------------------------------------------------------\n| Specific Grid Styles\n------------------------------------------------------------------- */\n.ezTimeEntryGridContainer {\n    display: grid;\n    align-content: stretch;\n    justify-content: stretch;\n    grid-template-columns: auto;\n    grid-template-rows: auto;\n    padding: 8px;\n    margin-top: 10px;\n    background-color: var(--ezAlphaBackgroundWhite2);\n}\n\n\n/* -------------------------------------------------------------------\n| Generic Top Level Grid Styles\n------------------------------------------------------------------- */\n.ezFullScreen {\n    display: grid;\n    width: 100%;\n    height: 100%;\n}\n\n.ezGridX {\n    display: grid;\n    color: var(--ezFontColor);\n    font-family: var(--ezFontFamily);\n    font-size: var(--ezFontSize);\n    font-weight: var(--ezFontWeight);\n    font-style: var(--ezFontStyle);\n}\n\n.ezGridHeader {\n    display: grid;\n    padding: 6px;\n    color: var(--ezTopicFontColor);\n    font-family: var(--ezFontFamily);\n    font-size: var(--ezTopicFontSize);\n    font-weight: var(--ezTopicFontWeight);\n    font-style: var(--ezTopicFontStyle);\n}\n\n.ezGridHeader-navy {\n    display: grid;\n    justify-content: start;\n    align-content: center;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezTopicFontColorWhite);\n    font-size: var(--ezTopicFontSize);\n    font-weight: var(--ezTopicFontWeight);\n    font-style: var(--ezTopicFontStyle);\n    border-color: var(--ezBorderNavy);\n    border-style: solid;\n    border-width: 1px;\n}\n\n.ezGridContent {\n    display: grid;\n    padding: 4px;\n    color: var(--ezContentFontColor);\n    font-family: var(--ezFontFamily);\n    font-size: var(--ezContentFontSize);\n    font-weight: var(--ezContentFontWeight);\n    font-style: var(--ezContentFontStyle);\n}\n\n.ezGridFullPage {\n    display: grid;\n    height: 100%;\n}\n\n.ezRowItem-container_2Col {\n    display: grid;\n    grid-template-columns: max-content auto;\n    justify-content: stretch;\n    align-content: center;\n    grid-column-gap: 4px;\n    grid-row-gap: 0;\n    padding: 8px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezFontColor);\n    font-size: var(--ezFontSize);\n    font-weight: var(--ezFontWeight);\n    font-style: var(--ezTopicFontStyle);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 2px;\n}\n\n.ezRowItem-container-disabled_2Col {\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerStone);\n    border-color: var(--ezClockerStone);\n}\n\n.ezRowItem-container-archived_2Col {\n    display: grid;\n    grid-template-rows: none;\n    justify-content: stretch;\n    align-content: center;\n    grid-column-gap: 4px;\n    grid-row-gap: 0;\n    padding: 8px;\n    background-color: var(--ezClockerGray);\n    color: var(--ezClockerWhite);\n    font-size: var(--ezFontSize);\n    font-weight: var(--ezFontWeight);\n    font-style: var(--ezTopicFontStyle);\n    border-color: var(--ezBorderGray);\n    border-style: solid;\n    border-width: 1px;\n}\n\n.ezRowItem-text_col-1of2 {\n    display: grid;\n    grid-column: 1/2;\n    grid-row: 1;\n    justify-content: start;\n    align-content: center;\n}\n\n.ezRowItem-button-container_col-2of2 {\n    display: grid;\n    grid-template-columns: auto auto;\n    grid-column: 2/2;\n    grid-row: 1;\n    justify-content: end;\n    align-content: center;\n}\n\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Grid Row and Column Gap Styles\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n/* DEPRECATED */\n.ezNoGridColumnGap,\n/* DEPRECATED */\n.ezGridNoGap,\n.ezGridGap-none {\n    display: grid;\n    grid-column-gap: 0;\n    column-gap: 0;\n}\n\n.ezGridGap_R1_C1 {\n    display: grid;\n    grid-row-gap: 1px;\n    grid-column-gap: 1px;\n}\n\n/* DEPRECATED */\n.ezGridGap,\n/* DEPRECATED */\n.ezGridGap_2,\n.ezGridGap_R2_C2 {\n    display: grid;\n    grid-row-gap: 2px;\n    grid-column-gap: 2px;\n}\n\n/* DEPRECATED */\n.ezGridGap_4,\n.ezGridGap_R4_C4 {\n    display: grid;\n    grid-row-gap: 4px;\n    grid-column-gap: 4px;\n}\n\n.ezGridGap_R6_C6 {\n    display: grid;\n    grid-row-gap: 6px;\n    grid-column-gap: 6px;\n}\n\n/* DEPRECATED */\n.ezGridGap_8,\n.ezGridGap_R8_C8 {\n    display: grid;\n    grid-row-gap: 8px;\n    grid-column-gap: 8px;\n}\n\n.ezGridGap_R10_C10 {\n    display: grid;\n    grid-row-gap: 10px;\n    grid-column-gap: 10px;\n}\n\n/* DEPRECATED */\n.ezGridGap_20,\n.ezGridGap_R20_C20 {\n    display: grid;\n    grid-row-gap: 20px;\n    grid-column-gap: 20px;\n}\n\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Grid Row Gap Styles\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n/* DEPRECATED */\n.ezGrid-row-gap-0,\n.ezGrid-no-row-gap {\n    display: grid;\n    grid-row-gap: 0;\n}\n\n/* DEPRECATED */\n.ezGridColumnGap,\n.ezGrid-col-gap_1 {\n    display: grid;\n    grid-column-gap: 1px;\n}\n\n.ezGrid-row-gap_2 {\n    display: grid;\n    grid-column-gap: 2px;\n}\n\n.ezGrid-row-gap_4 {\n    display: grid;\n    grid-row-gap: 4px;\n}\n\n.ezGrid-row-gap_6 {\n    display: grid;\n    grid-row-gap: 6px;\n}\n\n.ezGrid-row-gap_8 {\n    display: grid;\n    grid-row-gap: 8px;\n}\n\n.ezGrid-row-gap_10 {\n    display: grid;\n    grid-row-gap: 10px;\n}\n\n.ezGrid-row-gap_20 {\n    display: grid;\n    grid-row-gap: 20px;\n}\n\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Grid Column Gap Styles\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n.ezGrid-col-gap_1 {\n    display: grid;\n    grid-column-gap: 1px;\n}\n\n.ezGrid-col-gap_2 {\n    display: grid;\n    grid-column-gap: 2px;\n}\n\n/* DEPRECATED */\n.ezGrid-col-gap-4,\n.ezGrid-col-gap_4 {\n    display: grid;\n    grid-column-gap: 4px;\n}\n\n.ezGrid-col-gap_6 {\n    display: grid;\n    grid-column-gap: 6px;\n}\n\n.ezGrid-col-gap_8 {\n    display: grid;\n    grid-column-gap: 8px;\n}\n\n.ezGrid-col-gap_10 {\n    display: grid;\n    grid-column-gap: 10px;\n}\n\n.ezGrid-col-gap_20 {\n    display: grid;\n    grid-column-gap: 20px;\n}\n\n\n\n\n\n/* -------------------------------------------------------------------\n| Grid Text Styles\n------------------------------------------------------------------- */\n.ezGridContentText {\n    color: var(--ezContentFontColor);\n    font-family: var(--ezFontFamily);\n    font-size: var(--ezContentFontSize);\n    font-weight: var(--ezContentFontWeight);\n    font-style: var(--ezContentFontStyle);\n}\n\n.ezGridRowLabelText {\n    color: var(--ezFontColor);\n    font-family: var(--ezFontFamily);\n    font-weight: var(--ezFontWeight);\n    font-style: var(--ezFontStyle);\n    font-size: var(--ezLayoutGrid-row-label-font-size);\n}\n\n.ezGridNormalText {\n    color: var(--ezFontColor);\n    font-family: var(--ezFontFamily);\n    font-size: var(--ezFontSize);\n    font-weight: var(--ezFontWeight);\n    font-style: var(--ezFontStyle);\n}\n\n.ezGridTopicText {\n    color: var(--ezClockerWhite);\n    font-family: var(--ezFontFamily);\n    font-size: var(--ezTopicFontSize);\n    font-weight: var(--ezTopicFontWeight);\n    font-style: var(--ezTopicFontStyle);\n}\n\n\n/* -------------------------------------------------------------------\n| Grid Background Styles\n------------------------------------------------------------------- */\n.ezGridWhite {\n    background-color: var(--ezClockerWhite);\n    color: var(--ezContentFontColor);\n    border-radius: 3px;\n}\n\n.ezGridBlack {\n    background-color: var(--ezClockerBlack);\n    color: var(--ezClockerWhite);\n    border-radius: 3px;\n}\n\n.ezGridNavy {\n    background-color: var(--ezNavy);\n    color: var(--ezNavyContainerTextColor);\n    border-radius: 3px;\n}\n\n.ezGridGray {\n    background-color: var(--ezGray);\n    color: var(--ezGrayContainerText);\n    border-radius: 3px;\n}\n\n.ezGridStone {\n    background-color: var(--ezClockerStone);\n    color: var(--ezContentFontColor);\n    border-radius: 3px;\n}\n\n.ezGridYellow {\n    background-color: var(--ezYellow);\n    color: var(--ezYelloContainerText);\n    border-radius: 3px;\n}\n\n\n/* -------------------------------------------------------------------\n| Grid Horizontal Alignment Styles (X-Axis)\n------------------------------------------------------------------- */\n.ezGrid-align-left {\n    display: grid;\n    /* X-Axis */\n    justify-content: start;\n}\n\n.ezGrid-align-center {\n    display: grid;\n    /* X-Axis */\n    justify-content: center;\n}\n\n.ezGrid-align-right {\n    display: grid;\n    /* X-Axis */\n    justify-content: end;\n}\n\n.ezGrid-align-full {\n    display: grid;\n    /* X-Axis */\n    justify-content: stretch;\n}\n\n.ezGrid-align-space-between {\n    display: grid;\n    /* X-Axis */\n    justify-content: space-between;\n}\n\n.ezGrid-align-space-around {\n    display: grid;\n    /* X-Axis */\n    justify-content: space-around;\n}\n\n.ezGrid-align-space-evenly {\n    display: grid;\n    /* X-Axis */\n    justify-content: space-evenly;\n}\n\n\n/* -------------------------------------------------------------------\n| Grid Vertical Alignment Styles (Y-Axis)\n------------------------------------------------------------------- */\n.ezGrid-vertical-align-top {\n    display: grid;\n    /* Y-Axis */\n    align-content: start;\n}\n\n.ezGrid-vertical-align-middle {\n    display: grid;\n    /* Y-Axis */\n    align-content: center;\n}\n\n.ezGrid-vertical-align-bottom {\n    display: grid;\n    /* Y-Axis */\n    align-content: end;\n}\n\n.ezGrid-vertical-align-full {\n    display: grid;\n    /* Y-Axis */\n    align-content: stretch;\n}\n\n.ezGrid-vertical-space-evenly {\n    display: grid;\n    /* Y-Axis */\n    align-content: space-evenly;\n}\n\n.ezGrid-vertical-space-between {\n    display: grid;\n    /* Y-Axis */\n    align-content: space-between;\n}\n\n\n/* -------------------------------------------------------------------\n| Grid Vertical and Horizontal Alignment Styles\n------------------------------------------------------------------- */\n.ezGrid-fullsize {\n    display: grid;\n    /* X-Axis */\n    align-content: stretch;\n    /* Y-Axis */\n    justify-content: stretch;\n}\n\n.ezGrid-align-top-left {\n    display: grid;\n    /* X-Axis */\n    align-content: start;\n    /* Y-Axis */\n    justify-content: start;\n}\n\n.ezGrid-align-fullsize {\n    display: grid;\n    /* X-Axis */\n    align-content: stretch;\n    /* Y-Axis */\n    justify-content: stretch;\n}\n\n.ezGrid-align-middle-full-width {\n    display: grid;\n    /* X-Axis */\n    align-content: stretch;\n    /* Y-Axis */\n    justify-content: center;\n}\n\n.ezGrid-align-middle-left {\n    display: grid;\n    /* X-Axis */\n    align-content: center;\n    /* Y-Axis */\n    justify-content: start;\n}\n\n.ezGrid-align-middle-right {\n    display: grid;\n    /* X-Axis */\n    align-content: center;\n    /* Y-Axis */\n    justify-content: end;\n}\n\n.ezGrid-align-middle-center {\n    display: grid;\n    /* X-Axis */\n    align-content: center;\n    /* Y-Axis */\n    justify-content: center;\n}\n\n.ezGrid-align-top-space-evenly {\n    display: grid;\n    /* X-Axis */\n    align-content: start;\n    /* Y-Axis */\n    justify-content: space-between;\n}\n\n.ezGrid-x-space-between-y-stretch {\n    display: grid;\n    /* X-Axis */\n    align-content: center;\n    /* Y-Axis */\n    justify-content: space-evenly;\n}\n\n/* -------------------------------------------------------------------\n| Columns Classes for 2 Column Grids\n------------------------------------------------------------------- */\n.ezCol-1of2 {\n    display: grid;\n    grid-column: 1/2;\n}\n\n.ezCol-2of2 {\n    display: grid;\n    grid-column: 2/2;\n}\n\n/* -------------------------------------------------------------------\n| Columns Classes for 3 Column Grids\n------------------------------------------------------------------- */\n.ezCol-1of3 {\n    display: grid;\n    grid-column: 1/2;\n}\n\n.ezCol-2of3 {\n    display: grid;\n    grid-column: 2/2;\n}\n\n.ezCol-3of3 {\n    display: grid;\n    grid-column: 3/3;\n}\n\n/* -------------------------------------------------------------------\n| Columns Classes for 4 Column Grids\n------------------------------------------------------------------- */\n.ezCol-1of4 {\n    display: grid;\n    grid-column: 1/4;\n}\n\n.ezCol-2of4 {\n    display: grid;\n    grid-column: 2/4;\n}\n\n.ezCol-3of4 {\n    display: grid;\n    grid-column: 3/4;\n}\n\n.ezCol-4of4 {\n    display: grid;\n    grid-column: 3/4;\n}\n\n/* -------------------------------------------------------------------\n| Generic Row Grid Styles\n------------------------------------------------------------------- */\n.ezAutoRow {\n    display: grid;\n    grid-template-rows: auto;\n}\n\n.ezAutoRow_Min {\n    display: grid;\n    grid-template-rows: min-content;\n}\n\n.ezAutoRow_100 {\n    display: grid;\n    grid-template-rows: 100%;\n}\n\n/* -------------------------------------------------------------------\n| Two Row Grid Styles\n------------------------------------------------------------------- */\n.ezAutoRow_Min_2 {\n    display: grid;\n    grid-template-rows: min-content min-content;\n}\n\n.ezAutoRow_Min_Auto {\n    display: grid;\n    grid-template-rows: min-content auto;\n}\n\n.ezAutoRow_MinxMax,\n.ezAutoRow_Min_Max {\n    display: grid;\n    grid-template-rows: min-content max-content;\n}\n\n.ezAutoRow_600px_600px {\n    display: grid;\n    grid-template-columns: 600px 600px;\n}\n\n.ezAutoRow_Min_Min {\n    display: grid;\n    grid-template-rows: min-content min-content;\n}\n\n.ezAutoRow_A_Max {\n    display: grid;\n    grid-template-rows: auto max-content;\n}\n\n.ezAutoRow_A_min {\n    display: grid;\n    grid-template-rows: auto min-content;\n}\n\n.ezAutoRow_AxA,\n.ezAutoRow_A_A {\n    display: grid;\n    grid-template-rows: auto auto;\n}\n\n.ezAutoRow_50_A {\n    display: grid;\n    grid-template-rows: 50% auto;\n}\n\n.ezAutoRow_A_50 {\n    display: grid;\n    grid-template-rows: auto 50%;\n}\n\n.ezAutoRow_50x50,\n.ezAutoRow_50_50 {\n    display: grid;\n    grid-template-rows: 50% 50%;\n}\n\n/* -------------------------------------------------------------------\n| Three Row Grid Styles\n------------------------------------------------------------------- */\n.ezAutoRow_Min_3 {\n    display: grid;\n    grid-template-rows: min-content min-content min-content;\n}\n\n.ezAutoRow_A_A_A {\n    display: grid;\n    grid-template-rows: auto auto auto;\n}\n\n.ezAutoRow_33_A_33 {\n    display: grid;\n    grid-template-rows: 33% auto 33%;\n}\n\n.ezAutoRow_33_33_33 {\n    display: grid;\n    grid-template-rows: 33% 33% 33%;\n}\n\n.ezAutoRow_33_33_A {\n    display: grid;\n    grid-template-rows: 33% 33% auto;\n}\n\n.ezAutoRow_A_33_33 {\n    display: grid;\n    grid-template-rows: auto 33% 33%;\n}\n\n.ezAutoRow_25_A_25 {\n    display: grid;\n    grid-template-rows: 25% auto 25%;\n}\n\n.ezAutoRow_25_50_25 {\n    display: grid;\n    grid-template-rows: 25% 50% 25%;\n}\n\n.ezAutoRow_25_25_A {\n    display: grid;\n    grid-template-rows: 25% 25% auto;\n}\n\n.ezAutoRow_A_25_25 {\n    display: grid;\n    grid-template-rows: auto 25% 25%;\n}\n\n.ezAutoRow_1fr_2fr_1fr {\n    display: grid;\n    grid-template-rows: 1fr 2fr 1fr;\n}\n\n.ezAutoRow_Min_Max_A {\n    display: grid;\n    grid-template-rows: min-content, max-content, auto;\n}\n\n/* -------------------------------------------------------------------\n| Four Row Grid Styles\n------------------------------------------------------------------- */\n.ezAutoRow_AxAxAxA {\n    display: grid;\n    grid-template-rows: auto auto auto auto;\n}\n\n/* -------------------------------------------------------------------\n| Five Row Grid Styles\n------------------------------------------------------------------- */\n.ezAutoRow_AxAxAxAxA {\n    display: grid;\n    grid-template-rows: auto auto auto auto auto;\n}\n\n/* -------------------------------------------------------------------\n| One Column Grid Styles\n------------------------------------------------------------------- */\n.ezAutoCol_A {\n    display: grid;\n    grid-template-columns: auto;\n}\n\n.ezAutoCol_100 {\n    display: grid;\n    grid-template-columns: 100%;\n}\n\n.ezAutoCol_99 {\n    display: grid;\n    grid-template-columns: 99%;\n}\n\n\n/* -------------------------------------------------------------------\n| Two (TWO! HA HA HA!) Column Grid Styles\n------------------------------------------------------------------- */\n.ezAutoCol_83xA {\n    grid-template-columns: 83.33333333% auto;\n}\n\n.ezAutoCol_MinxA {\n    display: grid;\n    grid-template-columns: min-content auto;\n}\n\n.ezAutoCol_AxMin {\n    display: grid;\n    grid-template-columns: auto min-content;\n}\n\n.ezAutoCol_AxMax {\n    display: grid;\n    grid-template-columns: auto max-content;\n}\n\n.ezAutoCol_MinxMax {\n    display: grid;\n    grid-template-columns: min-content max-content;\n}\n\n.ezAutoCol_Max_Min {\n    display: grid;\n    grid-template-columns: max-content min-content;\n}\n\n.ezAutoCol_Max_A {\n    display: grid;\n    grid-template-columns: max-content min-content;\n}\n\n.ezAutoCol_Max_Max {\n    display: grid;\n    grid-template-columns: max-content max-content;\n}\n\n.ezAutoCol_AxA {\n    display: grid;\n    grid-template-columns: auto auto;\n}\n\n.ezAutoCol_50xA {\n    display: grid;\n    grid-template-columns: 50% auto;\n}\n\n.ezAutoCol_Ax70 {\n    display: grid;\n    grid-template-columns: auto 70%;\n}\n\n.ezAutoCol_Ax50 {\n    display: grid;\n    grid-template-columns: auto 50%;\n}\n\n.ezAutoCol_50x50 {\n    display: grid;\n    grid-template-columns: 50% 50%;\n}\n\n.ezAutoCol_200PXxA {\n    display: grid;\n    grid-template-columns: 200px auto;\n}\n\n.ezAutoCol_33xA {\n    display: grid;\n    grid-template-columns: 33% auto;\n}\n\n.ezAutoCol_Ax33 {\n    display: grid;\n    grid-template-columns: auto 33%;\n}\n\n.ezAutoCol_25xA {\n    display: grid;\n    grid-template-columns: 25% auto;\n}\n\n.ezAutoCol_Ax25 {\n    display: grid;\n    grid-template-columns: auto 25%;\n}\n\n.ezAutoCol_75xA {\n    display: grid;\n    grid-template-columns: 75% auto;\n}\n\n\n/* -------------------------------------------------------------------\n| Three (THREE! HA HA HA!) Column Grid Styles\n------------------------------------------------------------------- */\n.ezAutoCol_28px_28px_28px {\n    display: grid;\n    grid-template-columns: 28px 28px 28px;\n}\n\n.ezAutoCol_MinxMinxMin {\n    display: grid;\n    grid-template-columns: min-content min-content min-content;\n}\n\n.ezAutoCol_AxAxMin {\n    display: grid;\n    grid-template-columns: auto auto min-content;\n}\n\n.ezAutoCol_AxAxA {\n    display: grid;\n    grid-template-columns: auto auto auto;\n}\n\n.ezAutoCol_25x25xA {\n    display: grid;\n    grid-template-columns: 25% 25% auto;\n}\n\n.ezAutoCol_25xAx25 {\n    display: grid;\n    grid-template-columns: 25% auto 25%;\n}\n\n.ezAutoCol_Ax25x25 {\n    display: grid;\n    grid-template-columns: auto 25% 25%;\n}\n\n.ezAutoCol_33x33xA {\n    display: grid;\n    grid-template-columns: 33% 33% auto;\n}\n\n.ezAutoCol_33xAx33 {\n    display: grid;\n    grid-template-columns: 33% auto 33%;\n}\n\n.ezAutoCol_Ax33x33 {\n    display: grid;\n    grid-template-columns: auto 33% 33%;\n}\n\n.ezAutoCol_33x33x33 {\n    display: grid;\n    grid-template-columns: 33% 33% 33%;\n}\n\n.ezAutoCol_50x25xA {\n    display: grid;\n    grid-template-columns: 25% 25% auto;\n}\n\n.ezAutoCol_Ax50x25 {\n    display: grid;\n    grid-template-columns: auto 50% 25%;\n}\n\n.ezAutoCol_50xAx25 {\n    display: grid;\n    grid-template-columns: 50% auto 25%;\n}\n\n.ezAutoCol_50xAxA {\n    display: grid;\n    grid-template-columns: 50% auto auto;\n}\n\n.ezAutoCol_Ax50xA {\n    display: grid;\n    grid-template-columns: auto 50% auto;\n}\n\n.ezAutoCol_AxAx50 {\n    display: grid;\n    grid-template-columns: auto auto 50%;\n}\n\n.ezAutoCol_AxAx30px {\n    display: grid;\n    grid-template-columns: auto auto 33px;\n}\n\n.ezAutoCol_Ax75xA {\n    display: grid;\n    grid-template-columns: auto 75% auto;\n}\n\n/* -------------------------------------------------------------------\n| Four (FOUR! HA HA HA!) Column Grid Styles\n------------------------------------------------------------------- */\n.ezAutoCol_AxAxAxA {\n    display: grid;\n    grid-template-columns: auto auto auto auto;\n}\n\n.ezAutoCol_25x25xAxA {\n    display: grid;\n    grid-template-columns: 25% 25% auto auto;\n}\n\n.ezAutoCol_25x25x25xA {\n    display: grid;\n    grid-template-columns: 25% 25% 25% auto;\n}\n\n.ezAutoCol_25xAxAx25 {\n    display: grid;\n    grid-template-columns: 25% auto auto 25%;\n}\n\n.ezAutoCol_AxAxAx25 {\n    display: grid;\n    grid-template-columns: auto auto auto 25%;\n}\n\n.ezAutoCol_10xAxAx10 {\n    display: grid;\n    grid-template-columns: 10% auto auto 10%;\n}\n\n.ezAutoCol_AxAxAxMax {\n    display: grid;\n    grid-template-columns: auto auto auto max-content;\n}\n\n/* -------------------------------------------------------------------\n| Five (FIVE! MUHAHAHAHA!) Column Grid Styles\n------------------------------------------------------------------- */\n.ezAutoCol_AxAxAxAxA {\n    display: grid;\n    grid-template-columns: auto auto auto auto auto;\n}\n\n/* Column Spans */\n.ezColSpan_1a2 {\n    display: grid;\n    grid-column-start: 1;\n    grid-column-end: 2;\n}\n\n.ezColSpan_1a2a3 {\n    display: grid;\n    grid-column-start: 1;\n    grid-column-end: 3;\n}\n\n.ezColSpan_2a3 {\n    display: grid;\n    grid-column-start: 2;\n    grid-column-end: 3;\n}\n\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Sub-Grid Styles\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n.ezSubGridColRow {\n    display: grid;\n    grid-template-columns: subgrid;\n    grid-template-rows: subgrid;\n}\n\n.ezSubgridRow {\n    display: grid;\n    grid-template-rows: subgrid;\n}\n\n.ezSubGridCol {\n    display: grid;\n    grid-template-columns: subgrid;\n}\n\n\n/* -------------------------------------------------------------------\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 1024px) {\n}\n*/\n\n/* -------------------------------------------------------------------\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 768px) {\n}\n*/\n\n/* -------------------------------------------------------------------\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 480px) {\n}/\n\n/* -------------------------------------------------------------------\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 319px) {\n}\n*/\n\n/* -------------------------------------------------------------------\n| DEPRECATED STYLES\n------------------------------------------------------------------- */\n\n/* DEPRECATED */\n.ezPadTop2 {\n    padding-top: 2px;\n}\n\n/* DEPRECATED */\n.ezPadBottom2 {\n    padding-bottom: 2px;\n}\n\n/* DEPRECATED */\n.ezPadTopBottom2 {\n    padding-top: 2px;\n    padding-bottom: 2px;\n}\n\n/* DEPRECATED */\n.ezPadLeft2 {\n    padding-left: 2px;\n}\n\n/* DEPRECATED */\n.ezPadRight2 {\n    padding-right: 2px;\n}\n\n/* DEPRECATED */\n.ezPadLeftRight2 {\n    padding-left: 2px;\n    padding-right: 2px;\n}\n\n/* DEPRECATED */\n.ezPaddedBox4 {\n    padding: 4px;\n}\n\n/* DEPRECATED */\n.ezPadTop4 {\n    padding-top: 4px;\n}\n\n/* DEPRECATED */\n.ezPadBottom4 {\n    padding-bottom: 4px;\n}\n\n/* DEPRECATED */\n.ezPadTopBottom4 {\n    padding-top: 4px;\n    padding-bottom: 4px;\n}\n\n/* DEPRECATED */\n.ezPadLeft4 {\n    padding-left: 4px;\n}\n\n/* DEPRECATED */\n.ezPadRight4 {\n    padding-right: 4px;\n}\n\n/* DEPRECATED */\n.ezPadLeftRight4 {\n    padding-left: 4px;\n    padding-right: 4px;\n}\n\n/* DEPRECATED */\n.ezPadTop6 {\n    padding-top: 6px;\n}\n\n/* DEPRECATED */\n.ezPadBottom6 {\n    padding-bottom: 6px;\n}\n\n/* DEPRECATED */\n.ezPadTopBottom6 {\n    padding-top: 6px;\n    padding-bottom: 6px;\n}\n\n/* DEPRECATED */\n.ezPadLeft6 {\n    padding-left: 6px;\n}\n\n/* DEPRECATED */\n.ezPadRight6 {\n    padding-right: 6px;\n}\n\n/* DEPRECATED */\n.ezPadLeftRight6 {\n    padding-left: 6px;\n    padding-right: 6px;\n}\n\n/* DEPRECATED */\n.ezPadTop8 {\n    padding-top: 8px;\n}\n\n/* DEPRECATED */\n.ezPadBottom8 {\n    padding-bottom: 8px;\n}\n\n/* DEPRECATED */\n.ezPadTopBottom8 {\n    padding-top: 8px;\n    padding-bottom: 8px;\n}\n\n/* DEPRECATED */\n.ezPadLeft8 {\n    padding-left: 8px;\n}\n\n/* DEPRECATED */\n.ezPadRight8 {\n    padding-right: 8px;\n}\n\n/* DEPRECATED */\n.ezPadLeftRight8 {\n    padding-left: 8px;\n    padding-right: 8px;\n}\n\n/* DEPRECATED */\n.ezPadTop10 {\n    padding-top: 10px;\n}\n\n/* DEPRECATED */\n.ezPadBottom10 {\n    padding-bottom: 10px;\n}\n\n/* DEPRECATED */\n.ezPadTopBottom10 {\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n\n/* DEPRECATED */\n.ezPadLeft10 {\n    padding-left: 10px;\n}\n\n/* DEPRECATED */\n.ezPadRight10 {\n    padding-right: 10px;\n}\n\n/* DEPRECATED */\n.ezPadLeftRight10 {\n    padding-left: 10px;\n    padding-right: 10px;\n}\n\n/* DEPRECATED */\n.ezMargin2 {\n    margin: 2px;\n}\n\n/* DEPRECATED */\n.ezMarginTop2 {\n    margin-top: 2px;\n}\n\n/* DEPRECATED */\n.ezMarginBottom2 {\n    margin-bottom: 2px;\n}\n\n/* DEPRECATED */\n.ezMarginTopBottom2 {\n    margin-top: 2px;\n    margin-bottom: 2px;\n}\n\n/* DEPRECATED */\n.ezMarginLeft2 {\n    margin-left: 2px;\n}\n\n/* DEPRECATED */\n.ezMarginRight2 {\n    margin-right: 2px;\n}\n\n/* DEPRECATED */\n.ezMarginLeftRight2 {\n    margin-left: 2px;\n    margin-right: 2px;\n}\n\n/* DEPRECATED */\n.ezMargin4 {\n    margin: 4px;\n}\n\n/* DEPRECATED */\n.ezMarginTop4 {\n    margin-top: 4px;\n}\n\n/* DEPRECATED */\n.ezMarginBottom4 {\n    margin-bottom: 4px;\n}\n\n/* DEPRECATED */\n.ezMarginTopBottom4 {\n    margin-top: 4px;\n    margin-bottom: 4px;\n}\n\n/* DEPRECATED */\n.ezMarginLeft4 {\n    margin-left: 4px;\n}\n\n/* DEPRECATED */\n.ezMarginRight4 {\n    margin-right: 4px;\n}\n\n/* DEPRECATED */\n.ezMarginLeftRight4 {\n    margin-left: 4px;\n    margin-right: 4px;\n}\n\n/* DEPRECATED */\n.ezMargin8 {\n    margin: 8px;\n}\n\n/* DEPRECATED */\n.ezMarginTop8 {\n    margin-top: 8px;\n}\n\n/* DEPRECATED */\n.ezMarginBottom8 {\n    margin-bottom: 8px;\n}\n\n/* DEPRECATED */\n.ezMarginTopBottom8 {\n    margin-top: 8px;\n    margin-bottom: 8px;\n}\n\n/* DEPRECATED */\n.ezMarginLeft8 {\n    margin-left: 8px;\n}\n\n/* DEPRECATED */\n.ezMarginRight8 {\n    margin-right: 8px;\n}\n\n/* DEPRECATED */\n.ezMarginLeftRight8 {\n    margin-left: 8px;\n    margin-right: 8px;\n}\n\n/* DEPRECATED */\n.ezMargin10 {\n    margin: 10px;\n}\n\n/* DEPRECATED */\n.ezMarginTop10 {\n    margin-top: 10px;\n}\n\n/* DEPRECATED */\n.ezMarginBottom10 {\n    margin-bottom: 10px;\n}\n\n/* DEPRECATED */\n.ezMarginTopBottom10 {\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n/* DEPRECATED */\n.ezMarginLeft10 {\n    margin-left: 10px;\n}\n\n/* DEPRECATED */\n.ezMarginRight10 {\n    margin-right: 10px;\n}\n\n/* DEPRECATED */\n.ezMarginLeftRight10 {\n    margin-left: 10px;\n    margin-right: 10px;\n}\n\n/* -------------------------------------------------------------------\n| Legacy Auto-Column (experimental) Styles\n------------------------------------------------------------------- */\n/* DEPRECATED */\n.ezAutoCol1 {\n    display: grid;\n    min-height: 1px;\n    grid-template-columns: 8.33333333%;\n}\n\n/* DEPRECATED */\n.ezAutoCol2 {\n    display: grid;\n    min-height: 1px;\n    grid-template-columns: 16.66666667%;\n}\n\n/* DEPRECATED */\n.ezAutoCol3 {\n    display: grid;\n    min-height: 1px;\n    grid-template-columns: 25%;\n}\n\n/* DEPRECATED */\n.ezAutoCol4 {\n    display: grid;\n    min-height: 1px;\n    grid-template-columns: 33.33333333%;\n}\n\n/* DEPRECATED */\n.ezAutoCol5 {\n    display: grid;\n    min-height: 1px;\n    grid-template-columns: 41.66666667%;\n}\n\n/* DEPRECATED */\n.ezAutoCol6 {\n    display: grid;\n    min-height: 1px;\n    grid-template-columns: 50%;\n}\n\n/* DEPRECATED */\n.ezAutoCol7 {\n    display: grid;\n    min-height: 1px;\n    grid-template-columns: 58.33333333%;\n}\n\n/* DEPRECATED */\n.ezAutoCol8 {\n    display: grid;\n    min-height: 1px;\n    grid-template-columns: 66.66666667%;\n}\n\n/* DEPRECATED */\n.ezAutoCol9 {\n    display: grid;\n    min-height: 1px;\n    grid-template-columns: 75%;\n}\n\n/* DEPRECATED */\n.ezAutoCol10 {\n    display: grid;\n    min-height: 1px;\n    grid-template-columns: 83.33333333%;\n}\n\n/* DEPRECATED */\n.ezAutoCol11 {\n    display: grid;\n    min-height: 1px;\n    grid-template-columns: 91.66666667%;\n}\n\n/* DEPRECATED */\n.ezColumn12 {\n    display: grid;\n    min-height: 1px;\n    grid-template-columns: 100%;\n}\n\n/* DEPRECATED */\n.ezCenterBox {\n    display: flex;\n    text-align: right;\n    flex-direction: column;\n    align-items: center;\n}\n\n/* DEPRECATED */\n.ezBox {\n    display: inline-block;\n}\n\n/* DEPRECATED */\n.ezFooter {\n    padding: 4px;\n    height: 24px;\n    bottom: 0;\n    background-color: var(--ezClockerSilver);\n}\n\n/* DEPRECATED */\n.ezRightAlign {\n    text-align: right;\n}\n\n/* DEPRECATED */\ntd.ezclockerHeader2015Right {\n    vertical-align: middle;\n    text-align: right;\n}\n\n/* DEPRECATED */\n.ezInfoBox {\n    padding: 4px;\n    background-color: var(--ezClockerInfoYellow);\n    color: var(--ezClockerBlack);\n    border-style: solid;\n    border-color: var(--ezDarkYellow);\n    border-width: 1px;\n}\n\n/* DEPRECATED */\n.ezCell {\n    padding: 4px;\n    background-color: transparent;\n    color: var(--ezFontColor);\n    font-size: var(--ezFontSize);\n    font-weight: var(--ezFontWeight);\n    font-style: var(--ezFontStyle);\n    border-style: solid;\n    border-color: var(--ezClockerGray);\n    border-width: 1px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
